<template>
  <div>
    <SwappingSquaresSpinner v-if="this.$store.getters.isLoading"
      :animation-duration="1000"
      :size="90"
      :color="this.$store.getters.config.palette.primary"
      style="margin: auto; position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);"
    />
    <div class="row row-equal" v-if="!this.$store.getters.isLoading">
      <div class="flex xs6" >
        <div class="va-card">
          <div class="va-card__header-inner">
            <div class="va-card__header-title" style="color: rgb(44, 130, 224);"> {{paymentInfo.name}}</div>
          </div>
          <div class="va-card__body">
            <div class="pricing-table">
              <div class="pricing-option">
                <i class="material-icons">important_devices</i>
                <h1>{{paymentInfo.name}}</h1>
                <hr/>
                <p v-html="paymentInfo.description">{{paymentInfo.description}}</p>
                <hr/>
                <div class="price">
                  <div class="front">
                    <span class="price">{{ $t('payment.price') }}: {{paymentInfo.price}} <b>€</b></span>
                  </div>
                  <div class="front">
                    <span class="price">{{ $t('payment.includedVat') }}: {{paymentInfo.price !== paymentInfo.subscriptionInfo.price ? '24%' : '00%'}}</span><br>
                    <span class="price">{{ $t('payment.finalPrice') }}: {{paymentInfo.subscriptionInfo.price}} <b>€</b></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!this.$store.getters.isLoading" class="flex xs6">
        <div class="va-card">
          <div class="va-card__header-inner">
            <div class="va-card__header-title" style="color: rgb(44, 130, 224);"> {{ $t('payment.payWithCreditCard') }}</div>
          </div>
          <div class="va-card__body">
            <Stripe
              :amount="paymentInfo.subscriptionInfo.price"
              :subscription-plan-info-id="paymentInfo.subscriptionInfo.subscriptionPlanInfoId" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SwappingSquaresSpinner } from 'epic-spinners'
import Stripe from '../stripe/Stripe'
import errorHandlerMixin from '@/mixin/errorHandlerMixin'

export default {
  components: { SwappingSquaresSpinner, Stripe },
  mixins: [errorHandlerMixin],
  name: 'Payment',
  data () {
    return {
      paymentInfo: {},
    }
  },
  methods: {
    async initPayment () {
      this.paymentInfo = this.$store.getters.subscription
      this.$store.commit('setLoading', false)
    },
  },
  computed: {},
  created () {
    this.$store.commit('setLoading', true)
    this.$store.dispatch('getSubscription', this.$route.params.subscriptionId)
      .then(() => this.initPayment())
      .catch((err) => this.errorHandler(err.response))
  },
}
</script>

<style scoped type="scss">
  $icon-size: 3rem;
  $icon-color: #d8d8d8;
  $main-color: #f85e6a;

  .pricing-table {
    display: table;
    width: 100%;

    .pricing-option {
      width: 28%;
      background: white;
      float: left;
      padding: 2%;
      text-align: center;
      transition: all 0.3s ease-in-out;

      &:nth-child(even) {
        margin: 0 2%;
      }

      &:hover {
        cursor: pointer;
        box-shadow: 0 2px 30px rgba(0, 0, 0, 0.3);
        transform: scale(1.04);

        i,
        h1,
        span,
        b {
          color: $main-color;
        }

        .front {
          opacity: 0;
          visibility: hidden;
        }

        .back {
          opacity: 1 !important;
          visibility: visible !important;

          a.button {
            transform: translateY(0) !important;
          }
        }
      }

      hr {
        border: none;
        border-bottom: 1px solid #f0f0f0;
      }

      i {
        font-size: $icon-size;
        color: $icon-color;
        transition: all 0.3s ease-in-out;
      }

      h1 {
        margin: 10px 0;
        color: #212121;
        transition: all 0.3s ease-in-out;
      }

      p {
        color: #999999;
        padding: 0 10px;
        line-height: 1.3;
      }

      .price {
        position: relative;

        .front {
          span.price {
            font-size: 2rem;
            text-transform: uppercase;
            margin-top: 20px;
            display: block;
            font-weight: 700;
            position: relative;

            b {
              position: absolute;
              font-size: 1rem;
              margin-left: 2px;
              font-weight: 600;
            }
          }
        }

        .back {
          opacity: 0;
          visibility: hidden;
          transition: all 0.3s ease-in-out;

          a.button {
            background: $main-color;
            padding: 15px 20px;
            display: inline-block;
            text-decoration: none;
            color: white;
            position: absolute;
            font-size: 13px;
            top: -5px;
            left: 0;
            right: 0;
            width: 150px;
            margin: auto;
            text-transform: uppercase;
            transform: translateY(20px);
            transition: all 0.3s ease-in-out;

            &:hover {
              background: darken($main-color, 10%);
            }
          }
        }
      }
    }
  }

  @media screen and (max-width: 600px) {
    .pricing-table {
      .pricing-option {
        padding: 5%;
        width: 90%;

        &:nth-child(even) {
          margin: 30px 0 !important;
        }
      }
    }
  }
</style>
